<template lang="pug">
div.icon-wrapper(:class="classPosition")

    //- Exeception
    //- We don't use svg for frequency icon but the letter F with a hook
    span(v-if="name === 'frequency'", :title="title") &#402;

    FontAwesomeIcon(
        v-else-if="isFontawesomeIcon"
        :icon="getFontawesomeIcon"
        :title="title"
        :size="getFaSize(size)"
        class="icon"
        v-bind="{ fixedWidth, flip, rotation }"
    )

    svg(v-else :class="className" xmlns="http://www.w3.org/2000/svg")
        title(v-if="title") {{ title }}
        use(:xlink:href="iconPath")
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faShareFromSquare, faAngleRight, faTriangleExclamation, faCircleInfo, faInfo, faList, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'

const fontawesomeIcons = {
    shareFromSquare: faShareFromSquare,
    angleRight: faAngleRight,
    triangleExclamation: faTriangleExclamation,
    circleInfo: faCircleInfo,
    info: faInfo,
    list: faList,
    link: faArrowUpRightFromSquare
}

export default {
    name: 'SvgIcon',

    components: {
        FontAwesomeIcon
    },

    props: {
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: null
        },
        position: {
            type: String,
            default: null,
            validator: value => ['left', 'right', 'top', 'bottom', 'top-right', 'top-left', 'bottom-right', 'bottom-left'].indexOf(value) !== -1
        },
        size: {
            type: String,
            default: 'medium',
            validator: value => ['tiny', 'small', 'medium', 'large', 'xlarge', 'custom', 'big'].indexOf(value) !== -1
        },

        // map fontAwesomeIcon components props
        fixedWidth: {
            type: Boolean,
            default: false
        },
        rotation: {
            type: [String, undefined],
            default: undefined
        },
        flip: {
            type: String,
            default: undefined
        }
    },

    computed: {
        iconPath() {
            return require(`@/assets/icons/${this.name}.svg`).default.url
        },

        className() {
            return `icon icon-${this.name} icon-${this.size}`
        },

        classPosition() {
            const position = this.position !== null ? `icon--${this.position}` : ''
            return `${position}`
        },
        isFontawesomeIcon() {
            return fontawesomeIcons[this.name]
        },
        getFontawesomeIcon() {
            return fontawesomeIcons[this.name]
        }
    },

    methods: {
        getFaSize(size) {
            const mapper = {
                tiny: '2xs',
                small: 'xs',
                medium: undefined,
                large: 'lg',
                xlarge: 'xl',
                big: '2xl'
            }

            if (Object.values(mapper).includes(size)) return size
            return mapper[size]
        }
    }
}
</script>
